import { useAuthStore } from '@/stores/authStore';

export const useAuth = () => {
  const { user, isAuthenticated, isLoading, error, login, logout, validateToken, clearError } = useAuthStore();

  const hasRole = (roles: string | string[]): boolean => {
    if (!user) return false;
    const roleArray = Array.isArray(roles) ? roles : [roles];
    return roleArray.includes(user.role);
  };

  const canAccessRoute = (route: string): boolean => {
    if (!user) return false;
    
    const roleRoutes: Record<string, string[]> = {
      call_center: ['/search'],
      accountant: ['/search', '/dashboard', '/low-stock'],
      manager: ['/search', '/dashboard', '/low-stock'],
    };

    return roleRoutes[user.role]?.includes(route) || false;
  };

  return {
    user,
    isAuthenticated,
    isLoading,
    error,
    login,
    logout,
    validateToken,
    clearError,
    hasRole,
    canAccessRoute,
  };
};
